import { useState, useEffect } from 'react';
import { NavItemType } from 'types';
import viewsPages from 'menu-items/views-pages';
import { getDynamicExternalApps, loadDynamicExternalApps } from 'menu-items/dynamic-external-apps';
import {
  IconEdit,
  IconAddressBook,
} from '@tabler/icons-react';

// פונקציה שמחזירה את sidebar-pages עם אפליקציות דינמיות
const getSidebarPagesWithDynamicApps = (): NavItemType => {
  const staticItems = [
    {
      id: 'contacts',
      title: 'sidebar.nav.contacts',
      icon: IconAddressBook,
      type: 'item',
      url: '/contacts/chat',
    },
    {
      id: 'docSign',
      title: 'חתימה דיגיטלית',
      icon: IconEdit,
      type: 'item',
      url: '/docs-sign',
    },
  ];

  // הוספת אפליקציות חיצוניות דינמיות
  const dynamicExternalApps = getDynamicExternalApps();

  return {
    id: 'sidebar-pages',
    title: 'sidebar.nav.additionalPages',
    type: 'group',
    children: [
      ...staticItems,
      ...dynamicExternalApps,
    ],
  };
};

// Hook שמנהל את התפריט באופן דינמי
export const useDynamicMenuItems = () => {
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({
    items: [viewsPages, getSidebarPagesWithDynamicApps()],
  });

  // פונקציה שמעדכנת את התפריט
  const updateMenuItems = () => {
    setMenuItems({
      items: [viewsPages, getSidebarPagesWithDynamicApps()],
    });
  };

  // טעינת הרחבות מהשרת בעת טעינת הקומפוננטה
  useEffect(() => {
    loadDynamicExternalApps().then(() => {
      updateMenuItems();
    });
  }, []);

  // האזנה לשינויים באפליקציות חיצוניות
  useEffect(() => {
    const handleExternalAppsUpdate = () => {
      updateMenuItems();
    };

    // האזנה לאירוע מותאם אישית שנפלט כשמעדכנים אפליקציות
    window.addEventListener('externalAppsUpdated', handleExternalAppsUpdate);

    // ניקוי listeners כשה-component נמחק
    return () => {
      window.removeEventListener('externalAppsUpdated', handleExternalAppsUpdate);
    };
  }, []);

  return menuItems;
}; 